module.exports = __webpack_public_path__ + "img/mobile-about.82e9390e.png";